import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadTag, leadTagsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type ITagListByLeadState } from './types';

const LEAD_TAG_MODULE = 'leadTag';

const state: ITagListByLeadState = {
    tagListByLead: new Map()
};

const searchModule = getSearchModule<ILeadTag>(leadTagsManager);
const dataObjectModule = getDataObjectsModule<ILeadTag>(leadTagsManager);

const leadTagModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, getters, mutations });
store.registerModule(LEAD_TAG_MODULE, leadTagModuleInstance);

export { LEAD_TAG_MODULE };
